<template>
  <section>
    <stepper-step
      :complete="complete"
      title="Choose a Template"
      subtitle="Select from the list or type to search for a template by name."
      :step="$props.step"
    />

    <v-stepper-content v-bind="$props" v-on="$listeners">
      <div class="pt-4 d-flex">
        <select-list
          :value="formattedValue"
          :is-disabled="loading"
          :is-loading="loading"
          :items="pageTypeOptions"
          label="Page Type"
          class="mr-4 flex-grow-1"
          hide-details
          @input="onChange"
        />
        <v-btn color="primary" :loading="loading" :disabled="!complete" @click="onContinue">Continue</v-btn>
      </div>
    </v-stepper-content>
  </section>
</template>

<script>
import { VStepperContent } from 'vuetify/lib'

import StepperStep from './stepper-step.vue'
import SelectList from '@/components/forms/select-list'

export default {
  name: 'StepperPageTypeStep',
  components: { StepperStep, SelectList },
  extends: VStepperContent,
  props: {
    value: {
      type: [Number, null],
      default: null,
    },
    complete: {
      type: Boolean,
      default: false,
    },
    pageTypes: {
      type: Array,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    pageTypeOptions() {
      return this.pageTypes.map(({ id: value, name: key }) => ({ value, key }))
    },
  },
  methods: {
    onChange(item) {
      this.$emit('change', item)
    },
    onContinue() {
      this.$emit('increment')
    },
  },
}
</script>
